// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comments-block{margin-left:16px}.comments-block textarea.bp4-input,.comments-block textarea.bp4-input.bp4-small{height:32px;padding:2px}.comments-block .message{color:#404040;font-size:10pt;font-style:italic}.comments-block .sign{font-style:italic}", ""]);
// Exports
module.exports = exports;
